'use client';

import React, { ReactNode, useEffect, useState } from 'react';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';

interface CustomThemeProviderProps extends ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider: React.FC<CustomThemeProviderProps> = ({
  children,
  ...props
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true); // 클라이언트에서 렌더링되었을 때 상태 변경
  }, []);

  if (!mounted) {
    return null; // 서버 사이드 렌더링 시 아무것도 렌더링하지 않음
  }

  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
};

export default ThemeProvider;
